import FeatureFlag from "data/FeatureFlag"
import { Role } from "data/User"

export const getSettingTabs = (isOfmpAdmin: boolean, featureFlags: FeatureFlag) => {


  // Filter out automation settings tab and user roles tab if featureFlag not enabled
  let tabs = [
    {
      badge: { content: '', color: '', backgroundColor: '' },
      value: 'Email notifications',
      link: '/settings/email-notifications',
      allowedRoles: [Role.SuperAdmin, Role.VendorAdmin]
    },
    {
      badge: { content: '', color: '', backgroundColor: '' },
      value: 'Measurement units',
      link: '/settings/measurements',
      allowedRoles: [Role.SuperAdmin]
    },
  ]

  if (featureFlags?.businessUnit?.enabled) {
    tabs.push(...(isOfmpAdmin
      ? [{
        badge: { content: '', color: '', backgroundColor: '' },
        value: 'User roles',
        link: '/settings/user-roles',
        allowedRoles: [Role.SuperAdmin]
      }, {
        badge: { content: '', color: '', backgroundColor: '' },
        value: 'Email settings',
        link: '/settings/email-settings',
        allowedRoles: [Role.SuperAdmin]
      }]
      : []),
      {
        badge: { content: '', color: '', backgroundColor: '' },
        value: 'Automation Settings',
        link: '/settings/automation-settings',
        allowedRoles: [Role.SuperAdmin, Role.VendorAdmin]
      },
      ...(isOfmpAdmin
        ? [{
          badge: { content: '', color: '', backgroundColor: '' },
          value: 'Product Badges',
          link: '/settings/product-badges',
          allowedRoles: [Role.SuperAdmin]
        }]
        : [])
    )
  }

  return tabs;
}